import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import pageConfig from '../../config/page.config';
import { MHero } from '../../components/molecules';
import { OProjects, ODynamicStory, OMaatwerkStory } from '../../components/organisme';
import { draaibank, maatwerkHero, maatwerkCustom } from '../../assets/images/images/';
import { changeHead } from '../../redux/head/headActions';
import { fetchProjects } from '../../redux/content/contentActions';

const mapStateToProps = state => ({
	projects: state.content.projects.result,
});

class CustomizationPage extends React.Component {
	componentDidMount() {
		this.props.fetchProjects();
		this.props.changeHeadFunc({
			title: this.props.intl.formatMessage({ id: pageConfig.maatwerk.title }),
			description: this.props.intl.formatMessage({ id: pageConfig.maatwerk.description }),
			showSocialMedia: true,
		});
	}

	render() {
		let project;

		if (this.props.projects && this.props.projects.length) {
			project = <OProjects items={this.props.projects.slice(0, 3)} />;
		}

		return (
			<section>
				<MHero
					img={maatwerkHero}
					currentPage="BREAD_CRUMB.MAATWERK"
					className="a-hero--bottom-align"
				/>
				<article className="section-md layout-body--fill-with-hero">
					<ODynamicStory
						img={draaibank}
						description="MAATWERK.TEKST_1"
						className="t-gap--bottom-xx"
					/>
					{project}
					<OMaatwerkStory
						img={maatwerkCustom}
						description="MAATWERK.TEKST_2"
						className="t-gap--top-xx t-gap--bottom-xl"
					/>
				</article>
			</section>
		);
	}
}

CustomizationPage.propTypes = {
	changeHeadFunc: PropTypes.func.isRequired,
	fetchProjects: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, {
	changeHeadFunc: changeHead,
	fetchProjects,
})(injectIntl(CustomizationPage)));



// WEBPACK FOOTER //
// ./src/pages/about-us/customization.page.js